import { useState, useEffect } from "react";

// Decide whether to render heavy WebGL / 3D based on capability + user preference.
export function use3DEnabled() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    try {
      const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const coarse = window.matchMedia("(pointer: coarse)").matches;
      const cores = navigator.hardwareConcurrency || 4;
      const mem = navigator.deviceMemory || 4;
      const smallOrWeak = window.innerWidth < 820 || cores < 4 || mem < 4;

      let webgl = false;
      const c = document.createElement("canvas");
      webgl = !!(c.getContext("webgl2") || c.getContext("webgl"));

      setEnabled(webgl && !reduced && !(coarse && smallOrWeak));
    } catch {
      setEnabled(false);
    }
  }, []);

  return enabled;
}
